/**
 * @generated SignedSource<<0e22525016e37263ae8bbd09530c083d>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type AgentBadge_agent$fragmentType: FragmentType;
export type AgentBadge_agent$data = {|
  +clusterQueue: ?{|
    +cluster: ?{|
      +uuid: string,
    |},
    +id: string,
    +uuid: string,
  |},
  +name: string,
  +organization: ?{|
    +slug: string,
  |},
  +uuid: string,
  +version: ?string,
  +versionHasKnownIssues: boolean,
  +$fragmentType: AgentBadge_agent$fragmentType,
|};
export type AgentBadge_agent$key = {
  +$data?: AgentBadge_agent$data,
  +$fragmentSpreads: AgentBadge_agent$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentBadge_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "versionHasKnownIssues",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClusterQueue",
      "kind": "LinkedField",
      "name": "clusterQueue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Cluster",
          "kind": "LinkedField",
          "name": "cluster",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agent",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "edac9e00d8ff958efa9ff8b94bf03696";

module.exports = ((node/*: any*/)/*: Fragment<
  AgentBadge_agent$fragmentType,
  AgentBadge_agent$data,
>*/);
